<template>
    <div class="container-fluid" style="width: 1020px;">
        <!--Heading-->

        <div class="row">
            <div class="col-6 m-b-30">
                <h2 class="m-b-0">Purchase Order #{{poid}}</h2>
            </div>
            <div class="col-6 text-right">
                <div class="btn-group">
                    <button aria-expanded="false" aria-haspopup="true"
                            class="btn waves-effect waves-light btn-outline-success dropdown-toggle"
                            data-toggle="dropdown" type="button">
                        Action
                    </button>
                    <div class="dropdown-menu">
                        <a class="dropdown-item" data-target="#attachmentModal" data-toggle="modal"
                           href="javascript:void(0)">Upload Attachment</a>
                        <a class="dropdown-item" data-target="#storedAttachmentModal" data-toggle="modal"
                           href="javascript:void(0)">View Attachment</a>
                        <!--                        <a class="dropdown-item" href="javascript:void(0)">Void</a>-->
                        <div class="dropdown-divider"></div>
                        <!--                        <a class="dropdown-item" href="javascript:void(0)">Export as PDF</a>-->
                        <a @click="printPurchase()" class="dropdown-item" href="javascript:void(0)">Print</a>
                    </div>
                </div>
            </div>
        </div>

        <!--Quick Summary-->

        <div class="row" v-if="po">
            <div class="col-lg-3 col-md-6">
                <div class="d-flex align-items-center">
                    <div>
                        <h3>
                            <span class="label label-cyan" v-if="po.status === 'DRAFT'">Draft</span>
                            <span class="label label-inverse" v-if="po.status === 'CANCELLED'">Cancelled</span>
                            <span class="label label-primary" v-if="po.status === 'ISSUED'">Issued</span>
                            <span class="label label-warning" v-if="po.status === 'PARTIALLY_RECEIVED'">Partially Received</span>
                            <span class="label label-light-green" v-if="po.status === 'RECEIVED'">Received</span>
                            <span class="label label-dark-green" v-if="po.status === 'PAID'">Paid</span>
                        </h3>
                        <span>Status</span>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 col-md-6">
                <div class="d-flex align-items-center">
                    <div v-if="!po.member_did">
                        <h3 class="font-medium m-b-0"
                            v-if="currentOrg.type === 'COOP' && po.supplier && po.supplier.name">
                            {{po.supplier.name}}</h3>
                        <h3 class="font-medium m-b-0" v-if="currentOrg.type === 'COOP_MEMBER'">{{po.buyer.name}}</h3>
                        <span v-if="currentOrg.type === 'COOP'">Supplier</span>
                        <span v-if="currentOrg.type === 'COOP_MEMBER'">Buyer</span>
                    </div>
                    <div v-else>
                        <h3 class="font-medium m-b-0">
                            <did-details :catalog="po.member_catalog" :did="po.member_did"
                                         :show_blockie="true"></did-details>
                        </h3>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 col-md-6">
                <div class="d-flex align-items-center">
                    <div>
                        <h3 class="font-medium m-b-0">{{po.total | money}}</h3>
                        <span v-if="po.status !== 'PAID'">Amount Due</span>
                        <span v-if="po.status === 'PAID'">Amount Paid</span>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 col-md-6 text-right">
                <div class="ml-auto">
                    <div>
                        <h3 class="font-medium text-right m-b-0">{{po.expected_delivery || "—" | medium}}</h3>
                        <span class="text-right">Due Date</span>
                    </div>
                </div>
            </div>
        </div>

        <!--Action Cards-->

        <div class="row m-t-20" v-if="po">
            <div class="col-lg-12 col-md-12">
                <div class="card">
                    <div class="card-body">
                        <div class="d-flex no-block align-items-center">
                            <div>
                                <div class="step-badge">
                                    <div class="step-badge-inner" v-if="isDraft()">1</div>
                                    <div class="step-badge-inner step-badge-inner-checked" v-if="isCreated()"><i
                                            class="fas fa-check"></i></div>
                                </div>
                            </div>
                            <div class="p-10">
                                <h3 class="text-muted">Create Purchase Order</h3>
                                <h6 class="text-dark">Created: {{po.created_at | long}}</h6>
                            </div>
                            <div class="ml-auto">
                                <router-link :to="{name: 'edit-po'}"
                                             class="btn waves-effect waves-light btn-outline-success"
                                             type="button"
                                             v-if="isAdmin() && !isSupplier() && ['DRAFT','ISSUED'].includes(po.status)">
                                    Edit po
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-link"></div>
                <div class="card" v-bind:class="{'card-highlighted': isDraft()}">
                    <div class="card-body">
                        <div class="d-flex no-block align-items-center">
                            <div>
                                <div class="step-badge">
                                    <div class="step-badge-inner" v-if="!isIssued() && isDraft()">2</div>
                                    <div class="step-badge-inner step-badge-inner-checked"
                                         v-if="['ISSUED','RECEIVED','PARTIALLY_RECEIVED','PAID'].includes(po.status)"><i
                                            class="fas fa-check"></i>
                                    </div>
                                </div>
                            </div>
                            <div class="p-10">
                                <h3 class="text-muted">Approval</h3>
                                <h6 class="text-dark" v-if="!po.transition">Issued: Awaiting Approval</h6>
                                <h6 class="text-dark" v-if="po.transition">Issued: {{po.transition['ISSUED'] |
                                    long}}</h6>
                            </div>
                            <div class="ml-auto">
                                <button @click="approve()" class="btn waves-effect waves-light btn-outline-success"
                                        type="button" v-if="isDraft() && !isSupplier() && isAdmin()">Approve
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-link"></div>
                <div class="card"
                     v-bind:class="{'card-highlighted': ['DRAFT','ISSUED','PARTIALLY_RECEIVED'].includes(po.status)}">
                    <div class="card-body">
                        <div class="d-flex no-block align-items-center">
                            <div>
                                <div class="step-badge">
                                    <div class="step-badge-inner" v-if="!['RECEIVED','PAID'].includes(po.status)">3
                                    </div>
                                    <div class="step-badge-inner step-badge-inner-checked"
                                         v-if="['RECEIVED','PAID'].includes(po.status)"><i class="fas fa-check"></i>
                                    </div>
                                </div>
                            </div>
                            <div class="p-10">
                                <h3 class="text-muted">Receive Goods</h3>
                                <h6 class="text-dark" v-if="!['RECEIVED','PAID'].includes(po.status)">Due Date:
                                    {{po.expected_delivery || "—" | medium}}</h6>
                                <h6 class="text-dark" v-if="!['RECEIVED','PAID'].includes(po.status)">Status: Awaiting
                                    Items</h6>
                                <h6 class="text-dark" v-if="['RECEIVED','PAID'].includes(po.status)">Received:
                                    {{po.transition['RECEIVED'] | long}}</h6>
                            </div>
                            <div class="ml-auto">
                                <button class="btn waves-effect waves-light btn-outline-success" data-target="#myModal"
                                        data-toggle="modal" type="button"
                                        v-if="!isSupplier() && ['ISSUED','PARTIALLY_RECEIVED'].includes(po.status)">
                                    Receive
                                </button>
                                <button class="btn waves-effect waves-light btn-outline-success"
                                        data-target="#paymentModal" data-toggle="modal" type="button"
                                        v-if="!isSupplier() && ['RECEIVED'].includes(po.status)">
                                    Pay
                                </button>
                                <div aria-hidden="true" aria-labelledby="myModalLabel" class="modal fade" id="myModal"
                                     role="dialog" tabindex="-1">
                                    <div class="modal-dialog modal-lg">
                                        <div class="modal-content">
                                            <form @submit.prevent="handleSubmit" data-vv-scope="receive-commodity-form">
                                                <div class="modal-header">
                                                    <h4 class="modal-title" id="myModalLabel">Receive commodities</h4>
                                                    <button aria-hidden="true" class="close" data-dismiss="modal"
                                                            type="button">×
                                                    </button>
                                                </div>
                                                <div class="modal-body card-blue">
                                                    <div class="card-body">
                                                        <div class="form-group row">
                                                            <label class="col-sm-3 text-right control-label col-form-label"
                                                                   for="warehouse">Warehouse</label>
                                                            <div class="col-sm-7">
                                                                <div :class="{'is-invalid': submitted && errors.has('warehouse')}"
                                                                     class="form-control p-0-0">
                                                                    <multiselect
                                                                            :clear-on-select="false"
                                                                            :close-on-select="true"
                                                                            :hide-selected="true"
                                                                            :internal-search="false"
                                                                            :limit="3"
                                                                            :loading="isLoading"
                                                                            :max-height="600"
                                                                            :options="warehouses"
                                                                            :options-limit="300"
                                                                            :searchable="true"
                                                                            :show-no-results="false"
                                                                            @input="onSelect()"
                                                                            @search-change="getWareHouses"
                                                                            data-vv-as="warehouse"
                                                                            id="warehouse"
                                                                            label="warehouse"
                                                                            name="warehouse"
                                                                            open-direction="bottom"
                                                                            placeholder="Search warehouse"
                                                                            track-by="id"
                                                                            v-model="warehouse"
                                                                            v-validate="'required'">
                                                                        <template slot="singleLabel" slot-scope="props">
                                                                            {{props.option.name}}
                                                                        </template>
                                                                        <template slot="option" slot-scope="props">
                                                                            <div class="option__desc">
                                                                                <h5>{{ props.option.name }}</h5>
                                                                                <h6>{{ props.option.line1 +', '+
                                                                                    props.option.city+', '+
                                                                                    props.option.country}}</h6>
                                                                            </div>
                                                                        </template>
                                                                        <span slot="noResult">Warehouse not found</span>
                                                                    </multiselect>
                                                                </div>
                                                                <div class="invalid-feedback"
                                                                     v-if="submitted && errors.has('warehouse')">{{
                                                                    errors.first('warehouse') }}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="form-group row">
                                                            <label class="col-sm-3 text-right control-label col-form-label"
                                                                   for="purchaseItem">Commodity</label>
                                                            <div class="col-sm-7">
                                                                <div :class="{'is-invalid': submitted && errors.has('purchaseItem')}"
                                                                     class="form-control p-0-0">
                                                                    <multiselect
                                                                            :close-on-select="true"
                                                                            :options="items"
                                                                            :searchable="false"
                                                                            :show-labels="false"
                                                                            data-vv-as="commodity"
                                                                            id="purchaseItem"
                                                                            name="purchaseItem"
                                                                            placeholder="Select Commodity"
                                                                            v-model="purchaseItem"
                                                                            v-validate="'required'">
                                                                        <template slot="singleLabel"
                                                                                  slot-scope="{ option }">
                                                                            {{ option.name }}
                                                                        </template>
                                                                        <template slot="option" slot-scope="props">
                                                                            <div class="option__desc">
                                                                                <h5>{{ props.option.name }}</h5>
                                                                                <h6>Quantity due {{ props.option.due |
                                                                                    count }} {{
                                                                                    props.option.unit_symbol}}</h6>
                                                                            </div>
                                                                        </template>
                                                                    </multiselect>
                                                                </div>
                                                                <div class="invalid-feedback"
                                                                     v-if="submitted && errors.has('purchaseItem')">{{
                                                                    errors.first('purchaseItem') }}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="form-group row">
                                                            <label class="col-sm-3 text-right control-label col-form-label"
                                                                   for="quantity">Quantity</label>
                                                            <div class="col-sm-7">
                                                                <input :class="{'is-invalid': submitted && errors.has('quantity')}"
                                                                       class="form-control"
                                                                       data-vv-as="quantity"
                                                                       id="quantity"
                                                                       name="quantity"
                                                                       placeholder="Quantity"
                                                                       ref="quantity"
                                                                       step="any"
                                                                       type="number"
                                                                       v-model="quantity"
                                                                       v-validate="'required'">
                                                                <div class="invalid-feedback"
                                                                     v-if="submitted && errors.has('quantity')">{{
                                                                    errors.first('quantity') }}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="form-group row" v-if="purchaseItem">
                                                            <label class="col-sm-3 text-right control-label col-form-label"
                                                                   for="unit">Unit</label>
                                                            <div class="col-sm-7">
                                                                <input class="form-control"
                                                                       id="units"
                                                                       readonly
                                                                       type="text"
                                                                       v-model="purchaseItem.unit_name">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="modal-footer">
                                                    <button class="btn waves-effect waves-light btn-success"
                                                            type="submit">Submit
                                                    </button>
                                                    <button @click="reset()"
                                                            class="btn waves-effect waves-light btn-secondary"
                                                            type="button">Reset
                                                    </button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                                <div aria-hidden="true" aria-labelledby="myModalLabel" class="modal fade"
                                     id="paymentModal" role="dialog" tabindex="-1">
                                    <div class="modal-dialog modal-md">
                                        <div class="modal-content">
                                            <form @submit.prevent="handleSubmit">
                                                <div class="modal-header">
                                                    <h4 class="modal-title" id="paymentModalLabel">Payment Details</h4>
                                                    <button aria-hidden="true" class="close" data-dismiss="modal"
                                                            type="button">×
                                                    </button>
                                                </div>
                                                <div class="modal-body card-blue">
                                                    <div class="card-body">
                                                        <div class="tab-content">
                                                            <div class="tab-pane active" id="iprofile" role="tabpanel">
                                                                <div class="row">
                                                                    <!--<div class="col-md-7">-->
                                                                    <form>
                                                                        <div class="row">
                                                                            <div class="col-xs-7 col-md-7">
                                                                                <div class="form-group">
                                                                                    <label>Payee (Supplier)</label>
                                                                                    <input :value="po.supplier.biz_name"
                                                                                           class="form-control"
                                                                                           name="Expiry"
                                                                                           readonly required=""
                                                                                           type="text"
                                                                                           v-if="po.supplier.id">
                                                                                </div>
                                                                            </div>
                                                                            <div class="col-xs-5 col-md-5 pull-right">
                                                                                <div class="form-group">
                                                                                    <label>Payer</label>
                                                                                    <input :value="po.buyer.biz_name"
                                                                                           class="form-control"
                                                                                           name="CVC" readonly
                                                                                           type="text">
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div class="row">
                                                                            <div class="col-md-12">
                                                                                <div class="form-group">
                                                                                    <label>Amount to Pay</label>
                                                                                    <input :value="po.total | money"
                                                                                           class="form-control"
                                                                                           name="nameCard" readonly
                                                                                           type="text">
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </form>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="modal-footer">
                                                    <button @click="payPo()" class="btn btn-success">Make Payment
                                                    </button>
                                                    <button class="btn waves-effect waves-light btn-danger"
                                                            data-dismiss="modal"
                                                            type="button">Cancel
                                                    </button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                                <div aria-hidden="true" aria-labelledby="myModalLabel" class="modal fade"
                                     id="attachmentModal" role="dialog" tabindex="-1">
                                    <div class="modal-dialog modal-lg">
                                        <div class="modal-content">
                                            <form>
                                                <div class="modal-header">
                                                    <h4 class="modal-title" id="attachmentModalLabel">Upload
                                                        Attachments</h4>
                                                    <button @click="closeAttachmentModal()" aria-hidden="true"
                                                            class="close" data-dismiss="modal" type="button">×
                                                    </button>
                                                </div>
                                                <div class="modal-body card-blue">
                                                    <div class="card-body">
                                                        <div class="form-group row">
                                                            <div class="col-sm-12">
                                                                <input
                                                                        class="form-control"
                                                                        name="file_title"
                                                                        placeholder="Title"
                                                                        style="height: 42px;"
                                                                        type="text"
                                                                        v-model="fileTitle">
                                                            </div>
                                                        </div>
                                                        <div class="form-group row">
                                                            <div class="col-sm-12">
                                                                <textarea
                                                                        class="form-control"
                                                                        data-vv-as="description"
                                                                        id="description"
                                                                        name="description"
                                                                        placeholder="File Description"
                                                                        rows=3
                                                                        v-model="fileDesc">
                                                                </textarea>
                                                            </div>
                                                        </div>
                                                        <div class="form-group row">
                                                            <div class="input-group col-md-8">
                                                                <div class="custom-file">
                                                                    <input @change="onFileChange"
                                                                           class="custom-file-input"
                                                                           id="inputGroupFile01"
                                                                           ref="file"
                                                                           type="file">
                                                                    <label class="custom-file-label"
                                                                           for="inputGroupFile01"
                                                                           style="cursor: pointer">{{filename}}</label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="table-responsive p-t-25"
                                                             v-if="attachments.length >0">
                                                            <table class="table no-wrap v-middle">
                                                                <thead>
                                                                <tr class="bg-light">
                                                                    <th><h6>File Name</h6></th>
                                                                    <th><h6>Title</h6></th>
                                                                    <th><h6>Description</h6></th>
                                                                    <th><h6>Action</h6></th>
                                                                </tr>
                                                                </thead>
                                                                <tbody>
                                                                <tr v-bind:key="index"
                                                                    v-for="(a, index) in attachments">
                                                                    <td>{{a.filename}}</td>
                                                                    <td>{{a.title}}</td>
                                                                    <td>{{a.desc}}</td>
                                                                    <td>
                                                                        <a @click="deleteFile(a.id, a.filepath)"
                                                                           class="text-danger"
                                                                           href="javasript:void(0);">
                                                                            <b>Remove</b>
                                                                        </a>
                                                                    </td>
                                                                </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="modal-footer">
                                                    <button @click="saveAttachment()" class="btn btn-success"
                                                            data-dismiss="modal" type="button">Submit
                                                    </button>
                                                    <button @click="closeAttachmentModal()"
                                                            class="btn waves-effect waves-light btn-danger"
                                                            data-dismiss="modal"
                                                            type="button">Cancel
                                                    </button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                                <div aria-hidden="true" aria-labelledby="myModalLabel" class="modal fade"
                                     id="storedAttachmentModal" role="dialog" tabindex="-1">
                                    <div class="modal-dialog modal-lg">
                                        <div class="modal-content">
                                            <form>
                                                <div class="modal-header">
                                                    <h4 class="modal-title" id="storedAttachmentModalLabel">Stored
                                                        Attachments</h4>
                                                    <button aria-hidden="true" class="close" data-dismiss="modal"
                                                            type="button">×
                                                    </button>
                                                </div>
                                                <div class="modal-body card-blue">
                                                    <div class="card-body">
                                                        <h5 class="text-teal text-center"
                                                            v-if="storedAttachment.length ===0">No Attachment found</h5>
                                                        <div class="table-responsive" v-if="storedAttachment.length >0">
                                                            <table class="table no-wrap v-middle">
                                                                <thead>
                                                                <tr class="bg-light">
                                                                    <th class="border-0"><h6>File Name</h6></th>
                                                                    <th class="border-0"><h6>Title</h6></th>
                                                                    <th class="border-0"><h6>Description</h6></th>
                                                                    <th class="border-0"><h6>Action</h6></th>
                                                                </tr>
                                                                </thead>
                                                                <tbody>
                                                                <tr v-bind:key="index"
                                                                    v-for="(a, index) in storedAttachment">
                                                                    <td>{{a.filename}}</td>
                                                                    <td>{{a.title}}</td>
                                                                    <td>{{a.desc}}</td>
                                                                    <td>
                                                                        <a @click="downloadFile(a.filename)"
                                                                           class="text-info"
                                                                           href="javasript:void(0);">
                                                                            <b>Download</b>
                                                                        </a>
                                                                    </td>
                                                                </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="modal-footer">
                                                    <button class="btn waves-effect waves-light btn-danger"
                                                            data-dismiss="modal"
                                                            type="button">Close
                                                    </button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!--Purchase Order -->

        <div class="row hide" v-if="po">
            <div class="col-md-12" id="printMe">
                <div class="card">
                    <div class="card-header">
                        <div class="d-md-flex align-items-center m-b-0">
                            <div>
                                <h3 class="font-medium">
                                    {{po.po_number}}
                                </h3>
                                <h6 class="text-muted m-t-5" v-if="po.transition && po.transition.ISSUED">PO Issue Date: {{po.transition.ISSUED | date}}</h6>
                            </div>
                        </div>
                    </div>
                    <hr class="m-0">
                    <div class="card card-body printableArea">
                        <div class="row">
                            <div class="col-md-6">
                                <h5 class="font-bold text-muted">Billed From</h5>
                                <h4 class="m-t-5">{{po.buyer.biz_name}}</h4>
                                <p class="text-normal">
                                    {{po.buyer.line1}}, &nbsp;{{po.buyer.line2}}<br/>
                                    {{po.buyer.country}},&nbsp;{{po.buyer.city}}<br/>
                                    {{po.buyer.state}},&nbsp;{{po.buyer.postal_code}}<br/>
                                    <i class="fas fa-phone"></i>&nbsp;{{po.buyer.biz_phone}}<br/>
                                    <i class="fas fa-envelope"></i>&nbsp;{{po.buyer.biz_email}}<br/>
                                    <span v-html="po.buyer.description"></span>
                                </p>
                            </div>

                            <div class="col-md-6">
                                <h5 class="font-bold text-muted">PO Information</h5>
                                <!--                                <h4 class="m-t-5">{{invoice.po||invoice.notes }}</h4>-->

                                <div class="row">
                                    <div class="col-sm-4 col-lg-3 font-weight-bold">P.O. #</div>
                                    <div class="col-sm-8 col-lg-9">: {{po.po_number}}</div>


                                    <div class="col-sm-4 col-lg-3 font-weight-bold">P.O. Status</div>
                                    <div class="col-sm-8 col-lg-9">:
                                        <span v-if="po.status === 'DRAFT'">Draft</span>
                                        <span v-if="po.status === 'CANCELLED'">Cancelled</span>
                                        <span v-if="po.status === 'ISSUED'">Awaiting Shipment</span>
                                        <span v-if="po.status === 'PARTIALLY_RECEIVED'">Goods Partially Received</span>
                                        <span v-if="po.status === 'RECEIVED'">Goods Received</span>
                                        <span v-if="po.status === 'PAID'">Paid</span>
                                    </div>

                                    <div class="col-sm-4 col-lg-3 font-weight-bold">PO Issue Date</div>
                                    <div class="col-sm-8 col-lg-9" v-if="po.transition && po.transition.ISSUED">:
                                        {{po.transition.ISSUED | date }}
                                    </div>
                                    <div class="col-sm-8 col-lg-9" v-else>: NA</div>

                                    <div class="col-sm-4 col-lg-3 font-weight-bold">Delivery Date</div>
                                    <div class="col-sm-8 col-lg-9" v-if="po.transition && po.transition.RECEIVED">:
                                        {{po.transition.RECEIVED | medium}}
                                    </div>
                                    <div class="col-sm-8 col-lg-9" v-else>: NA</div>
                                </div>
                            </div>
                        </div>
                        <div class="row m-t-20">
                            <div class="col-md-6" v-if="po.supplier_address && po.supplier_address.line1">
                                <h5 class="font-bold text-muted">Billed To</h5>
                                <h4 class="m-t-5">{{po.supplier.biz_name}}</h4>
                                <p class="text-normal">
                                    {{po.supplier_address.line1}}, &nbsp;{{po.supplier_address.line2}}<br/>
                                    {{po.supplier_address.country}},&nbsp;{{po.supplier_address.city}}<br/>
                                    {{po.supplier_address.state}},&nbsp;{{po.supplier_address.postal_code}}<br/>
                                    <i class="fas fa-phone" v-if="po.supplier_address.biz_phone"></i>&nbsp;{{po.supplier_address.biz_phone}}<br/>
                                    <i class="fas fa-envelope" v-if="po.supplier_address.biz_email"></i>&nbsp;{{po.supplier_address.biz_email}}<br/>
                                    <span v-html="po.supplier_address.description"></span>
                                </p>
                            </div>
                            <div class="col-md-6" v-else>
                                <h5 class="font-bold text-muted">Billed To</h5>
                                <h4 class="m-t-5">{{po.supplier.biz_name}}</h4>
                                <p class="text-normal">
                                    {{po.supplier.line1}}, &nbsp;{{po.supplier.line2}}<br/>
                                    {{po.supplier.country}},&nbsp;{{po.supplier.city}}<br/>
                                    {{po.supplier.state}},&nbsp;{{po.supplier.postal_code}}<br/>
                                    <i class="fas fa-phone" v-if="po.supplier.biz_phone"></i>&nbsp;{{po.supplier.biz_phone}}<br/>
                                    <i class="fas fa-envelope" v-if="po.supplier.biz_email"></i>&nbsp;{{po.supplier.biz_email}}<br/>
                                    <span v-html="po.supplier.description"></span>
                                </p>
                            </div>

                            <div class="col-md-6" v-if="po.supplier_address && po.supplier_address.line1">
                                <h5 class="font-bold text-muted">Shipping Infromation</h5>
                                <h4 class="m-t-5">{{po.supplier.biz_name}}</h4>
                                <p class="text-normal">
                                    {{po.supplier_address.line1}}, &nbsp;{{po.supplier_address.line2}}<br/>
                                    {{po.supplier_address.country}},&nbsp;{{po.supplier_address.city}}<br/>
                                    {{po.supplier_address.state}},&nbsp;{{po.supplier_address.postal_code}}<br/>
                                    <i class="fas fa-phone" v-if="po.supplier_address.biz_phone"></i>&nbsp;{{po.supplier_address.biz_phone}}<br/>
                                    <i class="fas fa-envelope" v-if="po.supplier_address.biz_email"></i>&nbsp;{{po.supplier_address.biz_email}}<br/>
                                    <span v-html="po.supplier_address.description"></span>
                                </p>
                            </div>
                            <div class="col-md-6" v-else>
                                <h5 class="font-bold text-muted">Shipping Infromation</h5>
                                <h4 class="m-t-5">{{po.supplier.biz_name}}</h4>
                                <p class="text-normal">
                                    {{po.supplier.line1}}, &nbsp;{{po.supplier.line2}}<br/>
                                    {{po.supplier.country}},&nbsp;{{po.supplier.city}}<br/>
                                    {{po.supplier.state}},&nbsp;{{po.supplier.postal_code}}<br/>
                                    <i class="fas fa-phone" v-if="po.supplier.biz_phone"></i>&nbsp;{{po.supplier.biz_phone}}<br/>
                                    <i class="fas fa-envelope" v-if="po.supplier.biz_email"></i>&nbsp;{{po.supplier.biz_email}}<br/>
                                    <span v-html="po.supplier.description"></span>
                                </p>
                            </div>
                        </div>

                        <div class="row m-t-40">
                            <div class="col-md-12">
                                <h5 class="font-bold text-muted">Items</h5>
                            </div>

                            <div class="col-md-12">
                                <div class="table-responsive" style="clear: both;">
                                    <table class="table table-hover table-bordered">
                                        <thead>
                                        <tr>
                                            <th class="text-center">#</th>
                                            <th>Item</th>
                                            <th class="text-right">Quantity</th>
                                            <th class="text-right">Unit Cost</th>
                                            <th class="text-right">Total</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-bind:key="index" v-for="(pi, index) in po.items">
                                            <td class="text-center">{{index + 1}}</td>
                                            <td>{{pi.name}}</td>
                                            <td class="text-right">{{pi.quantity | units}}</td>
                                            <td class="text-right">{{pi.rate | money}} / {{pi.unit_symbol}}</td>
                                            <td class="text-right">{{pi.amount | money}}</td>
                                        </tr>
                                        <tr>
                                            <td class="text-right font-weight-bold" colspan="3">
                                                Item Total
                                            </td>
                                            <td class="text-right" colspan="2">
                                                {{po.total.currency_symbol}} {{po.item_total}}
                                            </td>
                                        </tr>
                                        <tr v-if="po.discount">
                                            <td class="text-right font-weight-bold" colspan="3">
                                                Discount
                                            </td>
                                            <td class="text-right" colspan="2">
                                                {{po.total.currency_symbol}} {{po.discount }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="text-right font-weight-bold" colspan="3">
                                                Total (In Figure)
                                            </td>
                                            <td class="text-right" colspan="2">
                                                {{po.total | money}}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="text-right font-weight-bold" colspan="3">
                                                Total (In Words)
                                            </td>
                                            <td class="text-right" colspan="2">
                                                {{po.total.amount | unitFix(2) | words}} Only
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="m-t-40">
                                    <b>Remarks :</b>
                                    <p>{{po.notes || 'N/A'}}</p>
                                </div>
                                <div class="clearfix"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row m-t-5" v-if="po">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <div class="d-md-flex align-items-center m-b-0 mt-3">
                            <div>
                                <h3>{{po.po_number}}</h3>
                                <h3>
                                    <span class="label label-cyan" v-if="po.status === 'DRAFT'">Draft</span>
                                    <span class="label label-inverse" v-if="po.status === 'CANCELLED'">Cancelled</span>
                                    <span class="label label-primary" v-if="po.status === 'ISSUED'">Issued</span>
                                    <span class="label label-warning" v-if="po.status === 'PARTIALLY_RECEIVED'">Partially Received</span>
                                    <span class="label label-light-green"
                                          v-if="po.status === 'RECEIVED'">Received</span>
                                    <span class="label label-dark-green" v-if="po.status === 'PAID'">Paid</span>
                                </h3>
                                <h5 class="font-medium" v-if="po.contract_number">
                                    <span class="text-muted">Contract # </span>
                                    <router-link
                                            :to="{name: 'view-marketplace-contract', params: {contractid: po.contract}}">
                                        {{po.contract_number}}
                                    </router-link>
                                </h5>
                            </div>
                            <div class="ml-auto">
                                <div>
                                    <h6 v-if="po.transition && po.transition.ISSUED">PO Issue Date: <span
                                            class="font-weight-normal">{{po.transition.ISSUED | date}}</span>
                                    </h6>
                                    <h6 v-if="po.transition && po.transition.RECEIVED">Delivery Date: <span
                                            class="font-weight-normal">{{po.transition.RECEIVED | date}}</span></h6>
                                    <h6 v-if="po.transition && po.transition.PAID">Payment Date: <span
                                            class="font-weight-normal">{{po.transition.PAID | date}}</span></h6>
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr>
                    <div class="card card-body printableArea">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="pull-left">
                                    <address>
                                        <h3><b class="text-danger">{{po.buyer.biz_name}}</b></h3>
                                        <h6 class="font-weight-normal" v-html="po.buyer.description">
                                            {{po.buyer.description}}</h6>
                                        <p class="text-muted m-b-5">
                                            <i class="fas fa-phone"></i>&nbsp;{{po.buyer.biz_phone}}<br/>
                                            <i class="fas fa-envelope"></i>&nbsp;{{po.buyer.biz_email}}
                                        </p>
                                        <p class="text-muted">
                                            {{po.buyer.line1}}&nbsp;{{po.buyer.line2}},
                                            <br/>{{po.buyer.country}},&nbsp;{{po.buyer.city}},
                                            <br/>{{po.buyer.state}},&nbsp;{{po.buyer.postal_code}}
                                        </p>
                                    </address>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="pull-right">
                                    <dl class="row mb-0">
                                        <div class="col-sm-8 offset-4 text-sm-left">
                                            <dt>Issued To:</dt>
                                            <dd class="mb-1">
                                                <h4 class="font-bold">{{po.supplier.biz_name}}</h4>
                                                <address v-if="po.supplier_address && po.supplier_address.line1">
                                                    <p class="text-muted">
                                                        <i class="fas fa-phone"></i>&nbsp;{{po.supplier_address.phone }}<br/>
                                                        <i class="fas fa-envelope" v-if="po.supplier_address.email"></i>&nbsp;{{po.supplier_address.email}}
                                                    </p>
                                                    <p class="text-muted">{{po.supplier_address.line1}}&nbsp;{{po.supplier_address.line2}},
                                                        <br/>{{po.supplier_address.country}},&nbsp;{{po.supplier_address.city}},
                                                        <br/>{{po.supplier_address.state}},&nbsp;{{po.supplier_address.zip}}
                                                    </p>
                                                </address>
                                                <address v-else>
                                                    <p class="text-muted">
                                                        <i class="fas fa-phone"></i>&nbsp;{{po.supplier.biz_phone
                                                        }}<br/>
                                                        <i class="fas fa-envelope" v-if="po.supplier.biz_email"></i>&nbsp;{{po.supplier.biz_email}}
                                                    </p>
                                                    <p class="text-muted">{{po.supplier.line1}}&nbsp;{{po.supplier.line2}},
                                                        <br/>{{po.supplier.country}},&nbsp;{{po.supplier.city}},
                                                        <br/>{{po.supplier.state}},&nbsp;{{po.supplier.postal_code}}</p>
                                                </address>
                                            </dd>
                                        </div>
                                    </dl>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="table-responsive m-t-40" style="clear: both;">
                                    <table class="table table-hover table-bordered">
                                        <thead>
                                        <tr>
                                            <th class="text-center">#</th>
                                            <th>Item</th>
                                            <th class="text-right">Quantity</th>
                                            <th class="text-right">Unit Cost</th>
                                            <th class="text-right">Total</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-bind:key="index" v-for="(pi, index) in po.items">
                                            <td class="text-center">{{index + 1}}</td>
                                            <td>{{pi.name}}</td>
                                            <td class="text-right">{{pi.quantity | units}}</td>
                                            <td class="text-right">{{pi.rate | money}} / {{pi.unit_symbol}}</td>
                                            <td class="text-right">{{pi.amount | money}}</td>
                                        </tr>
                                        <tr>
                                            <td class="text-right font-weight-bold" colspan="3">
                                                Item Total
                                            </td>
                                            <td class="text-right" colspan="2">
                                                {{po.total.currency_symbol}} {{po.item_total}}
                                            </td>
                                        </tr>
                                        <tr v-if="po.discount">
                                            <td class="text-right font-weight-bold" colspan="3">
                                                Discount
                                            </td>
                                            <td class="text-right" colspan="2">
                                                {{po.total.currency_symbol}} {{po.discount }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="text-right font-weight-bold" colspan="3">
                                                Total
                                            </td>
                                            <td class="text-right" colspan="2">
                                                {{po.total | money}}
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="pull-right m-t-20 text-right">
                                    <h3>Total: {{po.total | money}}</h3>
                                    <h5 class="font-weight-normal">{{po.total.currency_symbol}} {{ po.total.amount |
                                        unitFix(2) | words }} </h5>
                                </div>
                                <hr>
                                <div class="">
                                    <b>Remarks :</b>
                                    <p>{{po.notes || 'N/A'}}</p>
                                </div>
                                <hr>
                                <button @click="printPurchase"
                                        class="btn btn-outline-secondary waves-effect waves-light ml-2 float-right"
                                        type="button"><i class="fa fa-print"></i>
                                    Print
                                </button>
                                <div class="clearfix"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import Multiselect from 'vue-multiselect';
    import Blockie from '../../common/Blockie';
    import _ from "lodash";
    import Money from "../../../../models/Money";
    import axios from 'axios';
    import uuid from "uuid/v4";
    import DidDetails from "../../common/DidDetails";

    export default {
        name: "ViewPurchaseOrder",
        props: ["poid"],
        components: {DidDetails, Multiselect, Blockie},
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        data() {
            return {
                submitted: false,
                $BORLAUG: this.$BORLAUG,
                po: null,
                items: [],
                warehouses: [],
                warehouse: null,
                purchaseItem: null,
                quantity: null,
                activeWalletAddress: null,
                orgImg: null,
                file: File,
                filename: "Upload Attachment",
                uploadstatus: '',
                attachments: [],
                isLoading: false,
                fileTitle: '',
                fileDesc: '',
                storedAttachment: []
            };
        },
        mounted() {
            this.init();
            this.$root.$on('refreshPo', () => {
                this.init();
            })
        },
        methods: {
            async init() {
                await this.getPurchaseOrder();
                await this.getAddresses();
                await this.getAttachment();
            },
            isAdmin() {
                return this.currentOrg && this.currentOrg.role === 'ORG_ADMIN';
            },
            isDraft() {
                return this.po.status === 'DRAFT';
            },
            isCreated() {
                return this.po.status !== 'DRAFT';
            },
            isIssued() {
                return this.po.status === 'ISSUED';
            },
            async getPurchaseOrder() {
                $(".preloader").fadeIn();
                let reply = await this.$http.get(`/marketplaces/${this.currentOrg.marketplace_id}/purchases/${this.poid}`);

                $(".preloader").fadeOut();
                this.po = reply.data;
                this.items = _.filter(this.po.items, function (o) {
                    return Number(o.due) !== 0;
                });
                this.po.item_total = _.sumBy(this.po.items, function (o) {
                    return o.rate.amount * o.quantity.amount;
                });
            },
            async approve() {
                try {
                    $(".preloader").fadeIn();
                    await this.$http.post(`/marketplaces/${this.currentOrg.marketplace_id}/purchases/${this.poid}/approve`);
                    $(".preloader").fadeOut();
                    this.$toastr('success', 'Purchase order approved successfully.', 'Purchase Added');
                    this.getPurchaseOrder();
                } catch (e) {
                    $(".preloader").fadeOut();
                }
            },
            async getWareHouses(searchText) {
                let response = await this.$http.get(`/marketplaces/${this.currentOrg.marketplace_id}/purchases/warehouses/search`, {
                    params: {
                        search: searchText
                    }
                });

                this.warehouses = response.data;
            },
            async handleSubmit() {
                this.submitted = true;
                let valid = await this.$validator.validate();
                if (valid) {
                    if (Number(this.purchaseItem.due) < Number(this.quantity)) {
                        this.$toastr('error', 'Received quantity exceeded quantity due', 'Failed')
                    } else {
                        let receive = {
                            warehouseId: this.warehouse.id,
                            purchaseItemId: this.purchaseItem.id,
                            quantity: this.quantity,
                            unit_id: this.purchaseItem.unit_id
                        };
                        try {
                            await this.$http.post(`/marketplaces/${this.currentOrg.marketplace_id}/purchases/${this.poid}/receive`, receive);
                            this.$toastr('success', 'Commodity Received', 'Success');
                            $('#myModal').modal('hide');
                            this.reset();
                            this.getPurchaseOrder();
                        } catch (e) {
                            this.$toastr('error', e.response.data.reason, 'Failed');
                        }
                    }
                }
            },
            reset() {
                this.submitted = false;
                this.warehouse = null;
                this.purchaseItem = null;
                this.quantity = null;
            },
            async payPo() {
                $('#paymentModal').modal('hide');
                let total = new Money(this.po.total);

                try {
                    await this.$http.post(`/marketplaces/${this.currentOrg.marketplace_id}/purchases/${this.poid}/pay`, {
                        total: total,
                        walletAddress: this.activeWalletAddress,
                        comments: ''
                    });
                    $('#paymentModal').modal('hide');
                    this.$toastr('success', 'Purchase order payment successfully done.', 'Payment Successful');
                    this.getPurchaseOrder();
                } catch (e) {
                    if (e.response.status === 412) {
                        this.$toastr('error', 'Insufficient Balance to pay purchase order', 'Payment Failed');
                    }
                }
            },
            async getAddresses() {
                try {
                    let response = await this.$http.get("/wallets/addresses");
                    if (response.data !== null && response.data.length > 0) {
                        this.activeWalletAddress = _.find(response.data, {status: 'ACTIVE'}).address;
                    }
                } catch (e) {
                    console.log(err);
                }
            },
            isSupplier() {
                return this.currentOrg.id === this.po.supplier_id;
            },
            async onFileChange(e) {
                this.file = this.$refs.file.files[0];
                this.filename = this.file.name;
                this.uploadFile();
            },
            async uploadFile() {
                this.uploadstatus = "Uploading File Please Wait";
                let signedurl = await this.getUploadUrl();
                await axios.put(signedurl, this.file);
                this.resetAttachment();
            },
            async getUploadUrl() {
                let signedUrl = await this.$http.get(`/marketplaces/${this.currentOrg.marketplace_id}/purchases/${this.poid}/attachments/signedurl`, {
                    params: {
                        name: this.filename,
                        type: 'write'
                    }
                });

                let parts = this.filename.split(".");
                this.attachments.push({
                    id: uuid(),
                    filename: this.filename,
                    title: this.fileTitle,
                    desc: this.fileDesc,
                    filepath: signedUrl.data.key,
                    contenttype: parts[parts.length - 1]
                });

                return signedUrl.data.url;
            },
            async getDownloadUrl(filename) {
                let signedUrl = await this.$http.get(`/marketplaces/${this.currentOrg.marketplace_id}/purchases/${this.poid}/attachments/signedurl`, {
                    params: {
                        name: filename,
                        type: 'read'
                    }
                });
                return signedUrl.data.url;
            },
            async saveAttachment() {
                await this.$http.post(`/marketplaces/${this.currentOrg.marketplace_id}/purchases/${this.poid}/attachments`, {
                    attachments: this.attachments
                });
                this.uploadstatus = "";
                this.attachments = [];
                this.resetAttachment();
                this.getAttachment();
                this.$toastr('success', 'Attachment uploaded successfully', 'Success');
            },
            async getAttachment() {
                try {
                    let reply = await this.$http.get(`/marketplaces/${this.currentOrg.marketplace_id}/purchases/${this.poid}/attachments`);
                    this.storedAttachment = reply.data;
                } catch (e) {
                    console.log(e);
                }
            },
            async downloadFile(filename) {
                let signedUrl = await this.getDownloadUrl(filename);
                let link = document.createElement('a');
                link.download = filename;
                link.href = signedUrl;
                link.click();
            },
            async deleteFile(id, filepath) {
                await this.$http.delete(`/marketplaces/${this.currentOrg.marketplace_id}/purchases/${this.poid}/attachments`, {
                    data: {
                        filepath: filepath
                    }
                });
                _.remove(this.attachments, function (a) {
                    return a.id == id;
                });
                this.attachments = JSON.parse(JSON.stringify(this.attachments));
                this.resetAttachment();
                this.$toastr('success', 'Attachment deleted successfully', 'Success');
            },
            closeAttachmentModal() {
                this.attachments = [];
                this.resetAttachment();
            },
            resetAttachment() {
                this.file = File;
                this.filename = "Upload Attachment";
                this.fileTitle = "";
                this.fileDesc = "";
            },
            printPurchase() {
                this.$htmlToPaper('printMe');
            }
        }
    }
</script>

<style scoped>
    .step-badge {
        color: #cdd1d3;
        float: left;
        font-size: 25px;
        line-height: 50px;
        margin-right: 18px;
        text-align: center;
        border-width: 2px;
    }

    .step-badge-inner {
        background: #fff;
        border: 2px solid #019b40;
        border-radius: 50%;
        color: #019b40;
        width: 50px;
        height: 50px;
        line-height: 46px;
        box-sizing: border-box;
    }

    .step-badge-inner-checked {
        color: #fff;
        background: #019b40;
        border-color: #019b40;
        line-height: 50px;
    }
</style>
